/**
 * Supabase Client Singleton for Customer App
 *
 * This file creates a single Supabase client instance for the customer app
 * with app-scoped storage to prevent auth contamination across apps.
 *
 * @module lib/supabase
 */

import { createSupabaseClient } from '@rsvd/supabase-client'

/**
 * Customer app Supabase client singleton
 *
 * - Storage key: 'rsvd-customer-auth'
 * - Auto token refresh enabled
 * - Realtime subscriptions configured
 */
export const supabase = createSupabaseClient('customer')
